export async function affExternalShipmentsGetProductsByOrderUseCase(id, externalShipmentRepository) {

    const result = await externalShipmentRepository.aff_get_products_by_order(id);
    
    const entity = new externalShipmentRepository.aff_model_products_by_order(result.data.data);

    if (!entity.isValid()) {
        console.log(entity)
        throw new Error("External Shipments Aff get products by order Inválido");
    }
    
    return result.data.data;
}